export interface IStringInputSettings {
  name: string
  variant: StringVariants
  label?: string
  labelVariant?: LabelVariants
  placeholder?: string
  description?: string
  emptyErrorText?: string
  notValidErrorText?: string
  hasBadge?: boolean
  badgeText?: string
  disabled?: boolean
  badge: string | null
  isValidate: boolean
}

export interface ISelectInputSettings {
  name: string
  label: string
  errorText?: string
  placeholder?: string
  options: any
  defaultOption?: number
}

export interface IRadioInputSettings {
  name: string
  label: string
}

export interface IRadioInputData {
  label: string
  value: string
}

export enum KeyTypes {
  'delete' = 'delete',
  'backspace' = 'backspace',
  'default' = 'default',
}

export enum SelectVariants {
  'mobile' = 'mobile',
  'desktop' = 'desktop',
}

export enum StringVariants {
  'default' = 'default',
  'date' = 'date',
  'bankAccount' = 'bankAccount',
}

export enum LabelVariants {
  'outside' = 'outside',
  'default' = 'default',
}

export interface IInputLabel {
  variant: LabelVariants
  text: string
}

export interface IStateOptions {
  errorText?: string
  hasBadge?: boolean
  badgeText?: string
}

export enum Status {
  'idle' = 'idle',
  'error' = 'error',
  'success' = 'success',
}

export interface IState {
  status: Status
  options?: IStateOptions
}

export type ISelectChange = (
  //event: React.ChangeEvent<HTMLSelectElement>
  newValue: string
) => void
